import { LanguageCode } from "../../i18n/language";

/**
 * Navigation link texts translations.
 * - `key`: ID of the section.
 * - `value`: Translated text for the navigation link.
 */
export interface NavigationNavLinksTranslations {
    aboutMe: string;
    projects: string;
    contact: string;
}

/**
 * Translation resources for the navigation component.
 * - `navLinks`: Object containing translations for navigation link texts, where the key is the ID of the section, and the value is the translated text.
 */
export interface NavigationResourceTranslations {
    navLinks: NavigationNavLinksTranslations;
}

/**
 * Overall navigation translation resources structure.
 * - `key`: Language code.
 * - `value`: Object containing translations for the necessary navigation texts.
 */
type NavigationResource = {
    [Language in LanguageCode]: NavigationResourceTranslations;
}

export const navigationResource: NavigationResource = {
    nl: {
        navLinks: {
            aboutMe: 'Over mij',
            projects: 'Projecten',
            contact: 'Contact'
        }
    },
    en: {
        navLinks: {
            aboutMe: 'About Me',
            projects: 'Projects',
            contact: 'Contact'
        }
    }
};